export default __webpack_public_path__ + "static/media/551.f4c93d3d.jpg";